module.exports = __webpack_public_path__ + "static/media/MidwestTimes-devicecomp-min.ef2e4b1c.webp";